export default {
  contentMaxWidth: 720,
  tabletMaxWidthBreakpoint: 992,
  tabletContentMaxWidth: 940,
  desktopMaxWidthBreakPoint: 1200,
  desktopContentMaxWidth: 1140,
  padding: 16,
  desktopPadding: 20,
  fontSize: 18,
  smallFontSize: 16,
  textLineHeight: 1.5,
  boxBorderWidthAndRadius: 6,
}
